let currentOrientation = ""; // Track the current screen orientation

function updateVideoSource() {
  const homepageVideo = document.querySelector(".homepage-video");
  const videoElement = homepageVideo.querySelector("video");
  const mp4Source = homepageVideo.querySelector("source[type='video/mp4']");
  const desktopMp4Url = mp4Source.dataset.desktopSrc;
  const mobileMp4Url = mp4Source.dataset.mobileSrc;

  const newOrientation = window.innerHeight > window.innerWidth ? "portrait" : "landscape";

  if (newOrientation !== currentOrientation) {
    let newSource = ""; // New source URL
    if (newOrientation === "portrait") {
      newSource = mobileMp4Url || "";
    } else {
      newSource = desktopMp4Url || "";
    }

    if (newSource) {
      // Update the source only if it's different from the current one
      mp4Source.src = newSource;
      currentOrientation = newOrientation;
      console.log("Orientation changed to", currentOrientation);
      videoElement.load(); // Reload the video
    }
  }
}

function handleVideoUpdate() {
  updateVideoSource();

  let timeout;
  // Resize event listener
  window.addEventListener("resize", () => {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }
    timeout = window.requestAnimationFrame(function () {
      updateVideoSource();
    });
  });
}

// Call the function when on the homepage
const isHomepage = Boolean(document.querySelector(".homepage"));

if (isHomepage) {
  handleVideoUpdate();
}
